export const SERVEI_TO_APP = {
  SAL001: "RCSW",
  SAL015: "RCSW",
  SAL097: "RCSW",
  SAL101: "RCSW",
  SAL095: "RCSW",
  SAL102: "RCSW",
  SAL010: "RPM",
  SAL002: "GIA",
  SAL032: "RTVS",
  SAL104: "PRAM",
  SAL014: "RDAC",
  SAL076: "RTEA",
  SAL138: "RIS",
  SAL062: "RVA",
  "HC3 Enviament Vacunes": "REVAP"
};
